import React, { useState, useEffect } from "react";
import { Download, Printer,ArrowLeft, CheckCircle, AlertCircle } from "lucide-react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import sign from"./sign.svg";
import SignatureCanvas from "react-signature-canvas";
import "./FinalReport.css";
import config from './config';
import { userSession } from "../observers/userObserver";
import { sharedData } from '../sharedData/sharedData';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const FinalReport = ({ reportData = {} }) => {
  const transactionData = JSON.parse(localStorage.getItem("transaction") || "{}");
  const propertyData = JSON.parse(localStorage.getItem("propertyFormData") || "{}");
  const clientData = JSON.parse(localStorage.getItem("clientFormData") || "{}");
  const corporateFormData = JSON.parse(localStorage.getItem("corporateFormData") || "{}");
  // console.log("localStorage in report:",localStorage)

  const token = userSession.getToken()
  const [finalReportData, setFinalReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  // get property details
  const propertyDetails = [
    propertyData.propertyName,
    propertyData.addressLine1,
    propertyData.addressLine2,
    propertyData.addressLine3,
    propertyData.city,
    propertyData.state,
    propertyData.postcode,
  ]
  .filter(Boolean) // Remove undefined/null/empty values
  .join(", "); // Join with commas

  // get Registered Office Address
  const registeredOfficeAddress = [
    clientData.addressLine1,
    clientData.addressLine2,
    clientData.addressLine3,
    clientData.city,
    clientData.state,
    clientData.postCode
  ]  
  .filter(Boolean) // Remove undefined/null/empty values
  .join(", "); // Join with commas


  const managersData = JSON.parse(localStorage.getItem("managers") || "[]");

  const uboMapping = {
    "Private Individual (Natural Person)": "ubofullName",
    "Private Company": "uboCompanyName",
    "Partnership": "uboPartnershipName",
    "Company Listed on a Recognised Stock Exchange": "uboEntityName",
    "Regulated Entity": "uboEntityName",
    "Pension Fund": "uboPensionFundName",
    "Trust": "uboTrustName",
    "Unit Trust": "uboUnitTrustName",
    "Fund": "uboFundName",
    "Public Sector Bodies, governments, state owned companies and local authorities.": "uboGovernmentLocalName",
    "Foundations": "uboFoundationName",
    "Sovereign Wealth Funds": "uboSovereignWealthFundName",
    "Church bodies": "uboFullName",
    "Charities": "uboCharityName"
  };
  
  const formattedManagers = managersData
  .map(manager => {
    if (manager.managerEntity === "Individual" && manager.data.fullName) {
      return `Individual-${manager.data.fullName}`;
    } 
    if (manager.managerEntity === "Corporate" && manager.data.uboState) {
      const uboType = manager.data.uboState.type;
      const uboKey = uboMapping[uboType];
      if (uboKey && manager.data.uboState.data[uboKey]) {
        return `Corporate-${uboType}-${manager.data.uboState.data[uboKey]}`;
      }
    }
    return null; // Exclude entries with missing data
  })
  .filter(Boolean); // Remove null entries
  


  // Retrieve uploaded documents
  const getLoadedDocKeys = async () => {
    try {
      const pageName = window.location.pathname;
      const { entityId, requestId, email } = getStoredValues();  // Assuming getStoredValues is available

      const response = await axios.get(`${config['backend-url']}/documents`, {
        params: { page_name: pageName, entityId, requestId, email },
        headers: {
          Authorization: `Bearer ${userSession.getToken()}`, // Use token from userSession
        }
      });

      if (response.status === 200 && Array.isArray(response.data)) {
        console.log("response:", response);

        const docKeys = response.data.map(doc => {
          if (pageName === "/FinalReview" && doc.is_optional === false) {
            // const pageKey = doc.page_name?.startsWith("/") ? doc.page_name.substring(1) : doc.page_name || "unknown";
            // return `${pageKey}-${doc.document_type}`;
            return doc.document_type;
          } else {
            return doc.document_type;
          }
        });
        localStorage.setItem("loadedDocs", JSON.stringify(docKeys));
        console.log("localStorage after loaded:",localStorage)
        return docKeys;
      } else {
        return [];
      }
    } catch (error) {
      console.error("❌ Error fetching doc keys:", error);
      return [];
    }
  };

  const updatedDocs = JSON.parse(localStorage.getItem("loadedDocs") || "{}");

  const detailedDocs = JSON.parse(localStorage.getItem("detailedDocs") || "[]");


  // Check if ultimateBeneficialOwners
  let extractedData = [];

  if (corporateFormData.isUbo25Identified === "Yes" && Array.isArray(corporateFormData.ubos)) {
    // console.log("inside benificial Data:");
    extractedData = corporateFormData.ubos.map((ubo) => {
      const type = ubo.type;
      const key = uboMapping[type];
      // console.log("key",key);
      const name = key && ubo.data && ubo.data[key];
  
      return name ? `${type} - ${name}` : null;
    }).filter(Boolean); // Remove nulls in case of missing data
  }
  
  // console.log("Extracted Data:", extractedData);
  

  // get risktype
  const riskFormRaw = localStorage.getItem("riskFormData");
  const riskFormData = riskFormRaw ? JSON.parse(riskFormRaw) : {};
  // Helper to safely check if value is "Yes" (case insensitive)
  const isYes = (val) => {
    return typeof val === "string" && val.toLowerCase() === "yes";
  };

let PepStatus = "";

if (
  riskFormData.pep === 'Yes' &&
  riskFormData.pepOwner === 'No' &&
  riskFormData.sanctionedPerson === 'No'
) {
  PepStatus = "Verified";
} else {
  PepStatus = "Unverified";
}


let ClientCounterStatus = "";

if (
  riskFormData.understandClientBussiness =="Yes" &&
  riskFormData.particularTransaction== "Yes"
){
  ClientCounterStatus = 'Verified';
}
else{
  ClientCounterStatus = "Unverified"
}
 
let terroristFinancingStatus = "";
if (
  riskFormData.terroristFinancing =="No" &&
  riskFormData.financialCrime== "No"
){
  terroristFinancingStatus = 'Verified';
}
else{
  terroristFinancingStatus = "Unverified"
}


let SectorRiskStatus = '';

if (
  riskFormData.sectorFromDropdown =="None of the above" &&
  riskFormData.cashIntensive== "No"
){
  SectorRiskStatus = 'Verified';
}
else{
  SectorRiskStatus = "Unverified"
}

let BehaviourStatus = '';

if (
  riskFormData.pepEvasive =="No" &&
  riskFormData.transactionCompletedWithUndueSpeed== "No"
){
  BehaviourStatus = 'Verified';
}
else{
  BehaviourStatus = "Unverified"
}

let ReputationalStatus = '';

if (
  riskFormData.adverseSearch ==="Yes" &&
  riskFormData.adversePublicity === "No" &&
  riskFormData.adverseInformation ==="No" &&
  riskFormData.criminalProceedings=== "No"
){
  ReputationalStatus = 'Verified';
}
else{
  ReputationalStatus = "Unverified"
}

let TaxRiskStatus = '';

if (
  riskFormData.taxInvasionIndication =="No" 
){
  TaxRiskStatus = 'Verified';
}
else{
  TaxRiskStatus = "Unverified"
}


let DeliveryRiskStatus = '';

if (
  riskFormData.InfluenceTransaction =="No" 
){
  DeliveryRiskStatus = 'Verified';
}
else{
  DeliveryRiskStatus = "Unverified"
}
  
  // Define risk keys
  const pepRiskKeys = ["pep", "pepOwner", "sanctionedPerson"];
  const clientRiskKeys = ["understandClientBussiness", "particularTransaction"];
  const taxEvasionRiskKeys = ["taxInvasionIndication"];
  const sanctionsRiskKeys = ["adverseSearch", "adversePublicity","adverseInformation","criminalProceedings"];
  const behaviourRiskKeys = [
    "pepEvasive",
    "transactionCompletedWithUndueSpeed"
  ];
  
  // Generic function to check if any key has value "Yes"
  const hasRisk = (keys) => keys.some((key) => isYes(riskFormData[key]));

  // Helper to check if value is exactly "Yes"
  const isYess = (val) => typeof val === "string" && val.toLowerCase() === "yes";

  // Helper to check if a string has non-empty value
  const isNonEmpty = (val) => typeof val === "string" && val.trim() !== "None of the above";

  // Determine sector risk
  const isSectorRisk =
    isYess(riskFormData["cashIntensive"]) || isNonEmpty(riskFormData["sectorFromDropdown"]);

  
  // Risk calculations
  const isPEPRisk = hasRisk(pepRiskKeys);
  const isClientRisk = hasRisk(clientRiskKeys);
  const isTaxEvasionRisk = hasRisk(taxEvasionRiskKeys);
  const isSanctionsRisk = hasRisk(sanctionsRiskKeys);
  const isBehaviourRisk = hasRisk(behaviourRiskKeys);

  
  const [signature, setSignature] = useState("");
  const [mlnoName, setMlnoName] = useState("");
  const [mlnoDate, setMlnoDate] = useState("");
  const [uploadedSignature, setUploadedSignature] = useState(null);
  const [mlnoComments, setMlnoComments] = useState("");
  const [mlnoConsideration, setMlnoConsideration] = useState("");
  
  useEffect(() => {
    fetchMLNOData();
  }, []);
  
  const fetchMLNOData = async () => {
    // console.log("localstorage fetchMLNOData report:",localStorage)
    const sharedData = JSON.parse(localStorage.getItem("sharedData")) || {};
    const requestId = sharedData?.requestId;
  
    try {
      const response = await fetch(`${config["backend-url"]}/get_mlno_by_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ requestId }),
      });
  
      if (!response.ok) throw new Error("Failed to fetch MLNO data");
  
      const data = await response.json();
      console.log("mlno data:", data);
  
      if (data.mlno) {
        setSignature(data.mlno.Signature || "");
        setMlnoName(data.mlno.userName || ""); // replace with dynamic name if available
        setMlnoDate(data.mlno.CreatedDTTM?.split("T")[0] || "");
        setMlnoComments(data.mlno.MLNOComments || "");
        setMlnoConsideration(data.mlno.MLNOConsideration || "");
      }
    } catch (error) {
      console.error("❌ Error fetching MLNO data:", error);
    }
  };

  const getStoredValues = () => {
    try {
      let entityId = sharedData.get("entityId") || null;
      let requestId = sharedData.get("requestId") || null;
      const email = userSession.getUserEmail() || null;
      return { entityId, requestId, email };
    } catch (error) {
      console.error("❌ Error retrieving stored values:", error);
      return { entityId: null, requestId: null, email: null };
    }
  };

  useEffect(() => {
    const fetchDiligenceLevel = async () => {
      const sharedData = JSON.parse(localStorage.getItem("sharedData")) || {};
      const request_id = sharedData?.requestId;
      if (!request_id) {
        console.warn("Request ID not found in sharedData.");
        return;
      }
  
      try {
        const response = await fetch(`${config["backend-url"]}/get-request-status-type`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ request_id })
        });
  
        const result = await response.json();
  
        if (response.ok) {
          const level = result.RequestStatus_Type || "Not Available";
          console.log("✅ Diligence Level fetched:", level);
  
          // Update `data.dueDiligenceApplied`
          setData((prevData) => ({
            ...prevData,
            dueDiligenceApplied: level
          }));
        } else {
          console.error("Error fetching Diligence Level:", result.error);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
  
    fetchDiligenceLevel();
  }, []);

  
  const defaultData = {
    jurisdiction: propertyData.country || "",
    companyType: clientData.companyType || "",
    companyNumber: clientData.registrationNumber || "",
    companyName:clientData.companyName || "",
    registeredOfficeAddress: registeredOfficeAddress || "",
    dueDiligenceApplied: "",
    submittedDocuments: updatedDocs.length > 0 ? updatedDocs : ["No documents available"], // Ensure fallback
    transaction: transactionData.transactionType || "Sale",
    property: propertyDetails,
    priceDetails: transactionData.salePrice || transactionData.ratePerAnnum || transactionData.purchasePrice || " ",

    controllers: formattedManagers,
    ultimateBeneficialOwners: extractedData,
    pepRisk: isPEPRisk ? "Yes" : "No",
    sanctionsRisk: isSanctionsRisk ? "Yes" : "No",
    sectorRisk: isSectorRisk ? "Yes" : "No",
    behaviourRisk: isBehaviourRisk ? "Yes" : "No",
    clientRisk: isClientRisk ? "Yes" : "No",
    taxEvasionRisk: isTaxEvasionRisk ? "Yes" : "No",
    mlnoName,
    mlnoDate,
    mlnoSignature: signature,
  };

  const [data, setData] = useState({ ...defaultData, ...reportData });


  useEffect(() => {
    setData((prev) => ({ ...prev, mlnoSignature: signature }));
  }, [signature]);



  let sigPad = {};

  const handlePrint = () => {
    window.print();
  };
  const navigate = useNavigate();
const handleBack =() =>{
  navigate("/FinalReview");
  console.log('back to final review')
}
  const handleDownload = () => {
    const doc = new jsPDF();
    let y = 20;
  
    // Report Title
    doc.text("AML DealCheck – Client Due Diligence Report", 20, y);
    y += 10;
  
    // Client Information
    doc.text("Client/Counterparty Information", 20, y);
    y += 10;
    const clientInfo = [
      ["Jurisdiction", data.jurisdiction],
      ["Company Type", data.companyType],
      ["Company Number", data.companyNumber],
      ["Company Name", data.companyName],
      ["Registered Office Address", data.registeredOfficeAddress]
    ];
  
    autoTable(doc, {
      head: [["Field", "Value"]],
      body: clientInfo,
      startY: y
    });
  
    y = doc.lastAutoTable.finalY + 10; // Move `y` below the table
  
    // Due Diligence Applied
    doc.text(`Due Diligence Applied: ${data.dueDiligenceApplied}`, 20, y);
    y += 10;
  
    // Transaction Details
    doc.text(
      `Transaction: ${data.transaction} at/of ${data.property} for a ${data.priceDetails}`,
      20,
      y
    );
    y += 10;
  
    // Controllers & Management
    doc.text("Controllers & Management", 20, y);
    y += 5;
    data.controllers.forEach((controller, index) => {
      doc.text(`${index + 1}. ${controller}`, 25, y);
      y += 5;
    });
    y += 5;
  
    // Ultimate Beneficial Owners
    doc.text("Ultimate Beneficial Owners", 20, y);
    y += 5;
    data.ultimateBeneficialOwners.forEach((ubo, index) => {
      doc.text(`${index + 1}. ${ubo}`, 25, y);
      y += 5;
    });
    y += 5;
  
    // Submitted Documents Section
    doc.text("Submitted Documents", 20, y);
    y += 5;
    if (data.submittedDocuments.length > 0) {
      const documents = data.submittedDocuments.map((doc) => [doc]);
  
      autoTable(doc, {
        head: [["Document Name"]],
        body: documents,
        startY: y
      });
  
      y = doc.lastAutoTable.finalY + 10; // Update `y` after the table
    } else {
      doc.text("No documents submitted.", 25, y);
      y += 10;
    }
  // Risk Assessment
  doc.text("Risk Assessment", 20, y);
  y += 10;
  const riskAssessment = [
    ["Politically Exposed Person Risk", data.pepRisk],
    ["Sanctions Risk", data.sanctionsRisk],
    ["Sector Risk", data.sectorRisk],
    ["Behaviour Risk", data.behaviourRisk],
    ["Client/Counterparty Risk", data.clientRisk],
    ["Tax Evasion Risk", data.taxEvasionRisk]
  ];

  autoTable(doc, {
    head: [["Risk Type", "Assessment"]],
    body: riskAssessment.map(([label, value]) => [
      label,
      {
        content: value,
        styles: { textColor: value.toLowerCase() === "no" ? "green" : "red" }
      }
    ]),
    startY: y
  });

  y = doc.lastAutoTable.finalY + 10;

    // MLNO Comments & Sign Off
    doc.text("MLNO Comments & Sign Off", 20, y);
    y += 10;
    doc.text(`Name of MLNO: ${mlnoName}`, 20, y);
    y += 10;
    doc.text(`Date signed: ${mlnoDate}`, 20, y);
    y += 10;
    doc.text(`MLNO Comments: ${mlnoComments}`, 20, y);
    y += 10;
    doc.text(`Additional Considerations: ${mlnoConsideration}`, 20, y);
    y += 10;
  
    doc.save("final_report.pdf");
  };
  

  const getDueDiligenceClass = (value) => {
    switch (value.toLowerCase()) {
      case "simple":
        return "due-diligence-simple";
      case "standard":
        return "due-diligence-standard";
      case "enhanced":
        return "due-diligence-enhanced";
      case "simplified":
        return "due-diligence-simplified";
      default:
        return "due-diligence-default";
    }
  };
  const saveSignature = () => {
    setSignature(sigPad.getTrimmedCanvas().toDataURL("image/png"));
  };

  const clearSignature = () => {
    sigPad.clear();
    setSignature(null);
  };

  const handleUploadSignature = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedSignature(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  // if (loading || isEmptyValue(finalReportData)) {
  // return <div className="loading-spinner">Fetching report...</div>; // Can also be a spinner
  // }
  return (
    <div className="final-report-container">
      <div><button className="icon-button" onClick={handleBack}>
        <ArrowLeft size={20} />
        </button></div>
      <div className="icon-container">
        <button onClick={handlePrint} className="icon-button">
          <Printer size={20} />
        </button>
        {/* <button onClick={handleDownload} className="icon-button">
          <Download size={20} />
        </button> */}
      </div>
      <h2 className="report-title">AML DealCheck – Client Due Diligence Report</h2>
      
      <h3 className="section-title">Client/Counterparty Information</h3>
      <div className="section-container">

        <div className="info-row">
          <span className="info-label">Jurisdiction:</span>
          <span className="info-value">{data.jurisdiction}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Company Type:</span>
          <span className="info-value">{data.companyType}</span> {/* Ensure this matches defaultData */}
        </div>
        <div className="info-row">
          <span className="info-label">Company Number:</span>
          <span className="info-value">{data.companyNumber}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Company Name:</span>
          <span className="info-value">{data.companyName}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Registered Office Address:</span>
          <span className="info-value">{data.registeredOfficeAddress}</span>
        </div>
          
      </div>

      <div className={`due-diligence-container ${getDueDiligenceClass(data.dueDiligenceApplied)}`}>
        <span className="due-diligence-label">Due Diligence Applied: </span>
        <span className="due-diligence-value">{data.dueDiligenceApplied}</span>
      </div>
      <h3 className="section-title">Transaction</h3>
      <p>{data.transaction} at/of {data.property} for a {data.priceDetails}</p>
      
      <h3 className="section-title">Controllers & Management</h3>
      {data.controllers.length > 0 ? (
  <ul style={{ paddingLeft: '16px', marginLeft: 0 }}>
    {data.controllers.map((name, index) => (
      <li key={index}>{name}</li>
    ))}
  </ul>
) : (
  <p>No controllers listed.</p>
)}

      
      <h3 className="section-title">Ultimate Beneficial Owners</h3>
      <ul style={{ paddingLeft: '16px', marginLeft: 0 }}>
        {data.ultimateBeneficialOwners.length > 0 ? (
          data.ultimateBeneficialOwners.map((ubo, index) => <li key={index}>{ubo}</li>)
        ) : (
          <p>No ultimate beneficial owners listed.</p>
        )}
      </ul>
      
       {/* Risk Assessment Section */}
       <h3 className="section-title">Risk Assessment</h3>
     <div className="risk-assessment-container">
  {[
    ["PEP (Politically Exposed Person) & Sanctions Risk", PepStatus],
    ["Client / Counterparty Risk", ClientCounterStatus],
    ["Proliferation, Terrorist Financing & Financial Crime", terroristFinancingStatus],
    ["Sector Risk", SectorRiskStatus],
    ["Behaviour Risk", BehaviourStatus],
    ["Reputational Risk", ReputationalStatus],
    ["Tax Risk", TaxRiskStatus],
    ["Delivery Channel Risk", DeliveryRiskStatus]
  ].map(([label, value]) => {
    const isVerified = value === "Verified";
    return (
      <div key={label} className="risk-row">
        <span className="risk-label">{label}</span>
        <span className="risk-icon">
          {isVerified ? (
            <CheckCircle className="text-green-600 w-5 h-5" />
          ) : (
            <AlertCircle className="text-red-600 w-5 h-5" />
          )}
        </span>
      </div>
    );
  })}
</div>

      <h3 className="section-title">Underlying Due Diligence & Supporting Documentation</h3>
      <div className="documents-container">
        {detailedDocs.length > 0 ? (
          <div className="documents-columns">
            {Array.from({ length: Math.ceil(detailedDocs.length / 8) }, (_, colIndex) => (
              <div key={colIndex} className="documents-column">
                {detailedDocs
                  .slice(colIndex * 8, (colIndex + 1) * 8)
                  .map((doc, index) => (
                    <div key={index} className="document-item">
                      {colIndex * 8 + index + 1}.{" "}
                      <span>
                        {doc.certified ? "✅  " : ""}
                        {doc.docType || doc.filename}
                      </span>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        ) : (
          <p>No documents submitted.</p>
        )}
      </div>
      <h3 className="section-title">Additional Considerations</h3>
      <p>{mlnoConsideration || ""} </p>
      
      <h3 className="section-title">MLNO Comments & Sign Off</h3>
      <p>{mlnoComments || " "}</p>
      <div className="MLNO-field">
      <label>Name of MLNO:</label>
      <input type="text" value={mlnoName} disabled/>
      </div>
      <div className="MLNO-field">
      <label>Date signed:</label>
      <input type="date" value={mlnoDate} disabled/>
      </div>
      
      
      
    <div className="signature-container">
      <p>E-Signature:</p>
      {signature ? (
        <div className="signature-preview">
          <img src={signature} alt="MLNO Signature" className="signature-image" />
        </div>
      ) : (
        <p className="no-signature">No signature available.</p>
      )}
    </div>

      
    </div>
  );
};

export default FinalReport;
